// extracted by mini-css-extract-plugin
module.exports = {"QMenu":"quickMenu_QMenu__wXypj","danger":"quickMenu_danger__jX6Xk"};